import React from 'react';
import { FieldArrayWithId, useFormContext } from 'react-hook-form';
import { TableCell } from '@mui/material';

import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';
import KOGFileUploader from '@/main/components/shared/fileUploader/fileUploader';
import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';
import KOGSection from '@/main/components/shared/kogSection/kogSection';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';

import { KOGTableRow } from '@/main/components/shared/boxGrid/styles';
import { KeyValue } from '@/main/models/common';
import { getTranslateByKey } from '@/main/services/utils';

import { IFormValuesRegisterReportTemplate } from '../registerReportTemplateScreen';
import * as S from './styles';

interface ISectionFiltersProps {
  files: File[];
  fields: FieldArrayWithId<IFormValuesRegisterReportTemplate, 'filters', 'id'>[];
  optionsVariables: KeyValue[];
  isLoadingDocVariables: boolean;
  onReadFile: (file: File[]) => Promise<void>;
  onDeleteFile: (nameFile: string) => Promise<void>;
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
  generateIdScreen: (id: string) => string;
}
function SectionFilters({
  files,
  fields,
  optionsVariables,
  isLoadingDocVariables,
  onReadFile,
  onDeleteFile,
  setFiles,
  generateIdScreen
}: ISectionFiltersProps) {
  const {
    control,
    setValue,
  } = useFormContext<IFormValuesRegisterReportTemplate>();

  return (
    <KOGSection title={getTranslateByKey("information.filters")}>
      <S.Container>
        <KOGFileUploader
          isFullScreenDragDrop
          files={files}
          maxFiles={1}
          customTextDrop={getTranslateByKey('information.dropFileReportTemplate')}
          setFiles={setFiles}
          onCustomInsert={onReadFile}
          onCustomDelete={onDeleteFile}
          typeFiles={['docx']}
        />

        {isLoadingDocVariables ? <LoadingComponent /> :
          (fields.length > 0) &&
          <BoxGrid
            rowHeaders={[getTranslateByKey("information.variables"), getTranslateByKey("information.type")]}
            maxHeight='300px'
          >
            {fields.map((item, index) => (
              <KOGTableRow key={item.id} $notClickable>
                <TableCell>{`{{${item.variable}}}`}</TableCell>
                <TableCell>
                  <KogAutoCompleteControlled
                    required
                    id={generateIdScreen("drop-companyType")}
                    label={getTranslateByKey('information.variableType')}
                    nameCustom={`filters.${index}.type`}
                    control={control}
                    options={optionsVariables}
                    isLoading={false}
                    rulesCustom={{ required: true }}
                    onChangeCustom={() => { }}
                    setValueCustom={setValue}
                    disabled={false}
                  />
                </TableCell>
              </KOGTableRow>
            ))}
          </BoxGrid>
        }
      </S.Container>
    </KOGSection>
  )
}

export default SectionFilters